import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchasedCompleteItemDTO } from 'src/app/data/dto/BuyTicketsDTO';
import { UseCase } from '../../base/UserCase';
import { BuyTicketRepository } from '../../repositories/buyTickets/BuyTicketRepository';

@Injectable({
    providedIn: 'root'
})

export class GetPurchasedCompleteUseCase implements UseCase<number, PurchasedCompleteItemDTO[]> {
    constructor(
        private buyTicketRepository: BuyTicketRepository,
    ) { }

    execute(userId: number): Observable<PurchasedCompleteItemDTO[]> {
        return this.buyTicketRepository.getPurchasedComplete(userId);
    }
}
